export var BackupPaneName = 'outline-backup-pane';
export var MasterPaneName = 'outline-master-pane';